import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import {
  fetchUserSetting,
  fetchPublicFiles,
  fetchPrivateFiles,
  fetchGroupFiles,
  fetchEventTypes,
} from "./helper";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const SnaDataPrepare = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group, refreshUserInfo, refreshUserGroups } = user;
  const {
    dataset,
    refreshPublicDataset,
    refreshPersonalDataset,
    refreshGroupDataset,
    eventTypes,
  } = sna;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    // 取得使用者所有設定
    if (user?.uid) {
      fetchUserSetting(user, dispatch);
    }
  }, [user.uid]);

  useEffect(() => {
    if (user?.uid) {
      dispatch({
        type: Act.SNA_REFRESH_PUBLIC_DATASET,
        payload: true,
      });
      dispatch({
        type: Act.SNA_REFRESH_PERSONAL_DATASET,
        payload: true,
      });
      dispatch({
        type: Act.SNA_REFRESH_GROUP_DATASET,
        payload: true,
      });
    }
  }, [user.uid]);

  useEffect(() => {
    dispatch({
      type: Act.SNA_REFRESH_GROUP_DATASET,
      payload: true,
    });
  }, [group.uid]);

  useEffect(() => {
    if (refreshPublicDataset) {
      fetchPublicFiles(user, dispatch);
    }
  }, [user.uid, refreshPublicDataset]);

  useEffect(() => {
    // 時機：剛進入頁面時, 檔案上傳後, 刪除檔案後
    if (user?.uid && refreshPersonalDataset) {
      fetchPrivateFiles(user, dispatch);
    }
  }, [user.uid, refreshPersonalDataset]);

  useEffect(() => {
    // 時機：剛進入頁面時, 檔案上傳後, 刪除檔案後
    if (group?.uid && refreshGroupDataset) {
      fetchGroupFiles(group, dispatch);
    }
  }, [group.uid, refreshGroupDataset]);

  useEffect(() => {
    // 準備事件分類的資料
    if (!eventTypes && user.uid) {
      fetchEventTypes(user, dispatch);
    }
  }, [eventTypes, user]);

  return null;
};

SnaDataPrepare.propTypes = {};

SnaDataPrepare.defaultProps = {};

export default SnaDataPrepare;
